import {
  FETCH_DOCUMENT_DELIVERY_FORMATS_START,
  FETCH_DOCUMENT_DELIVERY_FORMATS_SUCCESS,
  FETCH_DOCUMENT_DELIVERY_FORMATS_FAIL,
} from "src/actionTypes";
import { DocumentDeliveryFormatType } from "src/types";

interface IState {
  documentDeliveryFormatsLoading: boolean;
  documentDeliveryFormats: DocumentDeliveryFormatType[];
}

type ActionType =
  | {
    type: 'FETCH_DOCUMENT_DELIVERY_FORMATS_START',
  }
  | {
    type: 'FETCH_DOCUMENT_DELIVERY_FORMATS_SUCCESS',
    payload: DocumentDeliveryFormatType[]
  }
  | { type: 'FETCH_DOCUMENT_DELIVERY_FORMATS_FAIL' };

const initialState: IState = {
  documentDeliveryFormatsLoading: true,
  documentDeliveryFormats: [],
};

const documentDeliveryFormatsReducer = (state = initialState, action: ActionType) => {
  switch (action.type) {
    case FETCH_DOCUMENT_DELIVERY_FORMATS_START:
      return { ...state, documentDeliveryFormatsLoading: true };
    case FETCH_DOCUMENT_DELIVERY_FORMATS_SUCCESS:
      return { ...state, documentDeliveryFormats: action.payload, documentDeliveryFormatsLoading: false };
    case FETCH_DOCUMENT_DELIVERY_FORMATS_FAIL:
      return { ...state, documentDeliveryFormatsLoading: false };

    default:
      return state;
  }
};

export default documentDeliveryFormatsReducer;
